import React, { useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../context/auth";
function HeaderMenu({ isOpen }) {
  const [auth, setAuth] = useAuth();
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const history = useHistory();
  const logout = () => {
    setAuth({});
    history.push("/login");
  };
  //   const toggleProfileMenu = () => {
  //     setIsProfileOpen((isOpen) => !isOpen);
  //   };
  return (
    <React.Fragment>
      <div
        className="ml-auto d-flex"
        style={{
          position: "absolute",
          left: "2px",
          top: "55px",
          width: "180px",
          height: "auto",
          display: "flex",
          flexFlow: "row",
          zIndex: 50,
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          padding: "10px",
          paddingLeft: "15px",
          paddingRight: "15px",
          backgroundColor: "#ffffff",
          borderRadius: "6px",
        }}
      >
        {/* <div
          style={{
            position: "absolute",
            top: -9,
            right: 10,
            width: 0,
            height: 0,
            borderLeft: "10px solid transparent",
            borderRight: "10px solid transparent",
            borderBottom: "10px solid #ffffff",
          }}
        ></div> */}
        <div isOpen={isOpen}>
          <div
            right
            style={{ display: "flex", flexFlow: "column", gap: "10px" }}
          >
            <div>
              <a
                href="https://trato.io/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-dark"
              >
                <FontAwesomeIcon
                  className="text-primary mr-2"
                  icon="external-link-alt"
                />{" "}
                Trato.io
              </a>
            </div>

            {/* <DropdownItem>
              <FontAwesomeIcon className="text-primary mr-2" icon="book" />
              <DocumentModal tag="span" DocumentComponent={TermsAndConditions}>
                Términos y Condiciones
              </DocumentModal>
            </DropdownItem>
            <DropdownItem>
              <FontAwesomeIcon
                className="text-primary mr-2"
                icon="book-reader"
              />
              <DocumentModal tag="span" DocumentComponent={PrivacyPolicy}>
                Aviso de Privacidad
              </DocumentModal>
            </DropdownItem> */}
            <div onClick={logout}>
              <FontAwesomeIcon
                className="text-primary mr-2"
                icon="sign-out-alt"
              />
              {"Cerrar Sesión"}
            </div>
          </div>
        </div>
        {/* <NavItem
          className="d-flex ml-4"
          hidden={profile?.plan?.type !== "premium"}
        >
          <span className="align-self-center text-accent">{t("Premium")}</span>
        </NavItem> */}
        {/* <NavItem className="d-flex ml-3">
                            <Link to="/shop" color="accent-100" className="btn btn-accent-100 animate-up align-self-center">{t('actions.buyNow')}</Link>
                        </NavItem> */}
      </div>
    </React.Fragment>
  );
}

export default HeaderMenu;
